import { Scores } from './ScoreIcon';
import { Emoji } from './icons/emoji';
import { Number } from './icons/number';
import { Star } from './icons/star';
import { Score, ScoreIconStyle } from './types';

interface AllIconsProps {
  scoreIconStyle: ScoreIconStyle;
  size: number;
  score: Score;
}

export const AllIcons = ({
  scoreIconStyle,
  size,
  score: selectedScore,
}: AllIconsProps): JSX.Element => {
  return (
    <>
      {Scores.map((score) => {
        switch (scoreIconStyle) {
          case 'stars':
            return (
              <Star
                key={`star-${score}`}
                score={score}
                size={size}
                isSelected={score <= selectedScore}
              />
            );
          case 'numbers':
            return (
              <Number
                key={`number-${score}`}
                score={score}
                size={size}
                isSelected={score <= selectedScore}
              />
            );
          case 'emojis':
          default:
            return (
              <Emoji
                key={`emoji-${score}`}
                score={score}
                size={size}
                isSelected={score === selectedScore}
              />
            );
        }
      })}
    </>
  );
};
